import BarChartIcon from "@mui/icons-material/BarChart";
import { type FC } from "react";

import { FilterRange } from "~/components/UI/FilterRange";

import { useVolumeRangeFilter } from "./useVolumeRangeFilter";

export const VolumeRangeFilter: FC = () => {
  const { onChangeVolumeFilter, initialValue } = useVolumeRangeFilter();

  return (
    <FilterRange
      label="Volume"
      icon={<BarChartIcon fontSize="inherit" />}
      initialValue={initialValue}
      onChange={onChangeVolumeFilter}
    />
  );
};
